import { FreshAsphalt50, Link } from './palette';

export const linkDefaultColor = Link;
export const linkDefaultColorHover = Link;
export const linkDefaultColorDisabled = FreshAsphalt50;
